import { ICrossLinks } from './types';

/**
 * Мок данных для рендера SeoCrossLinks.
 */
export const seoCrossLinksMock: ICrossLinks[] = [
  {
    title: 'квартиры в москве',
    links: [
      { name: 'Снять квартиру в Москве', uri: 'https://www.cian.ru/snyat-kvartiru/' },
      { name: 'Купить квартиру в Москве', uri: 'https://www.cian.ru/kupit-kvartiru/' },
      { name: 'Квартиры в новостройках Москвы', uri: 'https://www.cian.ru/kupit-novostroyka/' },
      { name: 'Квартиры вторичка Москва', uri: 'https://www.cian.ru/kupit-kvartiru-vtorichka/' },
      { name: 'Аренда 1-комнатной', uri: 'https://www.cian.ru/snyat-1-komnatnuyu-kvartiru/' },
      { name: 'Аренда 2-комнатной', uri: 'https://www.cian.ru/snyat-2-komnatnuyu-kvartiru/' },
      { name: 'Аренда 3-комнатной', uri: 'https://www.cian.ru/snyat-3-komnatnuyu-kvartiru/' },
      { name: 'Купить студию', uri: 'https://www.cian.ru/kupit-stodiyu/' },
      { name: 'Квартиры с ремонтом', uri: 'https://www.cian.ru/snyat-kvartiru-s-remontom/' },
      { name: 'Квартиры с мебелью', uri: 'https://www.cian.ru/snyat-kvartiru-s-mebelyu/' },
    ],
  },
  {
    title: 'районы москвы',
    links: [
      { name: 'ЦАО', uri: 'https://www.cian.ru/snyat-kvartiru-cao/' },
      { name: 'СВАО', uri: 'https://www.cian.ru/snyat-kvartiru-svao/' },
      { name: 'ВАО', uri: 'https://www.cian.ru/snyat-kvartiru-vao/' },
      { name: 'ЮВАО', uri: 'https://www.cian.ru/snyat-kvartiru-yuvao/' },
      { name: 'ЮАО', uri: 'https://www.cian.ru/snyat-kvartiru-yuao/' },
      { name: 'ЮЗАО', uri: 'https://www.cian.ru/snyat-kvartiru-yuzao/' },
      { name: 'ЗАО', uri: 'https://www.cian.ru/snyat-kvartiru-zao/' },
      { name: 'СЗАО', uri: 'https://www.cian.ru/snyat-kvartiru-szao/' },
    ],
  },
  {
    title: 'квартиры по типам',
    links: [
      { name: 'Студии', uri: 'https://www.cian.ru/snyat-stodiyu/' },
      { name: '1-комнатные', uri: 'https://www.cian.ru/snyat-1-komnatnuyu-kvartiru/' },
      { name: '2-комнатные', uri: 'https://www.cian.ru/snyat-2-komnatnuyu-kvartiru/' },
      { name: '3-комнатные', uri: 'https://www.cian.ru/snyat-3-komnatnuyu-kvartiru/' },
      { name: '4 и более', uri: 'https://www.cian.ru/snyat-4-komnatnuyu-kvartiru/' },
    ],
  },
];
